// Concat multiple classnames

export const cn = (...args) => {
  return args.filter((arg) => Boolean(arg)).join(' ')
}
